export function isNotUndefined<T>(input?: T): input is T {
  return input !== undefined;
}
